/**
 * Shared custom hook for managing document signing state
 */

import { useState } from "react";

export interface DocumentState {
  realUrl: string;
  documentId: number;
  completedAt: string;
  viewerKey: number;
  updateDocument: (url: string, id: number, completed: string) => void;
  clearUrl: () => void;
  incrementViewerKey: () => void;
  isDocumentSigned: boolean;
  isDocumentLoaded: boolean;
}

export const useDocumentState = () => {
  const [realUrl, setRealUrl] = useState("");
  const [documentId, setDocumentId] = useState(0);
  const [completedAt, setCompletedAt] = useState("");
  const [viewerKey, setViewerKey] = useState(0);

  const updateDocument = (url: string, id: number, completed: string) => {
    setRealUrl(url);
    setDocumentId(id);
    setCompletedAt(completed);
  };

  const clearUrl = () => {
    setRealUrl("");
  };

  const incrementViewerKey = () => {
    setViewerKey((prev) => prev + 1);
  };

  const isDocumentSigned = completedAt !== "";
  const isDocumentLoaded = realUrl !== "";

  return {
    realUrl,
    documentId,
    completedAt,
    viewerKey,
    updateDocument,
    clearUrl,
    incrementViewerKey,
    isDocumentSigned,
    isDocumentLoaded,
  };
};
